/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import {
  type IMentionSegment,
  segmentMentions,
} from 'uplisting-frontend/utils/team-mentions';

interface IArgs {
  body?: string | null;
  mentions?: ModelRegistry['team-mention'][];
}

interface TeamMessageBodySignature {
  Element: HTMLParagraphElement;

  Args: IArgs;
}

export default class UiTeamMessageBodyComponent extends Component<TeamMessageBodySignature> {
  @service intl!: Services['intl'];

  get segments(): IMentionSegment[] {
    const names = new Map<string, string>();

    for (const mention of this.args.mentions ?? []) {
      if (mention.userId && mention.name) {
        names.set(mention.userId, mention.name);
      }
    }

    return segmentMentions(
      this.args.body ?? '',
      names,
      this.intl.t('team.thread.mention_fallback'),
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Team::MessageBody': typeof UiTeamMessageBodyComponent;
  }
}
